(() => {
  const settings = document.getElementById('NbgSavedSettings');
  const dialog = document.getElementById('NbgSavedPieces');
  if (!settings || !dialog) return;
  const labels = settings.dataset;
  const root = labels.root.endsWith('/') ? labels.root : labels.root + '/';
  const keys = { saved: 'nbg-saved-pieces-v1', recent: 'nbg-recent-pieces-v1' };
  const validHandle = (value) => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,250}$/.test(value);
  let persistent = true;
  const read = (key) => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? [...new Set(data.filter(validHandle))].slice(0, 24) : [];
    } catch { persistent = false; return []; }
  };
  let saved = read(keys.saved);
  let recent = read(keys.recent);
  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); }
    catch { persistent = false; }
  };
  const status = document.querySelector('[data-nbg-save-status]');
  const grid = dialog.querySelector('[data-nbg-saved-grid]');
  const message = dialog.querySelector('[data-nbg-saved-message]');
  let opener;
  let renderVersion = 0;
  const sync = () => {
    document.querySelectorAll('[data-nbg-save]').forEach((button) => {
      const active = saved.includes(button.dataset.nbgSave);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? labels.remove : labels.save) + ': ' + button.dataset.productTitle);
      const text = button.querySelector('[data-nbg-save-label]');
      const caption = active ? labels.saved : labels.save;
      if (text && text.textContent !== caption) text.textContent = caption;
    });
    document.querySelectorAll('[data-nbg-open-saved]').forEach((button) => { button.hidden = false; });
    document.querySelectorAll('[data-nbg-saved-count]').forEach((count) => { if (count.textContent !== String(saved.length)) count.textContent = String(saved.length); count.hidden = saved.length === 0; });
  };
  async function loadCard(handle) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const url = root + 'products/' + encodeURIComponent(handle) + '?section_id=nbg-saved-card';
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) return null;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      return html.querySelector('.nbg-product-card');
    } catch { return null; }
    finally { clearTimeout(timer); }
  }
  async function loadCards(handles) {
    const cards = new Array(handles.length);
    let next = 0;
    await Promise.all(Array.from({length: Math.min(4, handles.length)}, async () => {
      while (next < handles.length) {
        const index = next++;
        cards[index] = await loadCard(handles[index]);
      }
    }));
    return cards.filter(Boolean);
  }
  async function renderSaved() {
    const version = ++renderVersion;
    const handles = [...saved];
    grid.replaceChildren();
    message.textContent = handles.length ? labels.loading : labels.empty;
    grid.setAttribute('aria-busy', 'true');
    const cards = await loadCards(handles);
    if (version !== renderVersion || !dialog.open) return;
    grid.replaceChildren(...cards);
    grid.setAttribute('aria-busy', 'false');
    message.textContent = cards.length < handles.length ? labels.error : handles.length ? '' : labels.empty;
    sync();
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nbg-save]');
    if (button) {
      event.preventDefault();
      const handle = button.dataset.nbgSave;
      if (!validHandle(handle)) return;
      const active = saved.includes(handle);
      if (!active && saved.length >= 24) { status.textContent = labels.limit; return; }
      saved = active ? saved.filter((item) => item !== handle) : [handle, ...saved];
      write(keys.saved, saved);
      sync();
      status.textContent = persistent ? (active ? labels.removed : labels.saved) : labels.visitOnly;
      if (dialog.open && active) {
        button.closest('.nbg-product-card')?.remove();
        if (!saved.length) message.textContent = labels.empty;
        dialog.querySelector('[data-nbg-close-saved]').focus();
      }
      return;
    }
    const open = event.target.closest('[data-nbg-open-saved]');
    if (open) { opener = open; dialog.showModal(); renderSaved(); return; }
    if (event.target.closest('[data-nbg-close-saved]')) dialog.close();
    if (event.target.closest('[data-nbg-clear-recent]')) {
      recent = [];
      write(keys.recent, recent);
      document.querySelectorAll('nbg-recent-pieces').forEach((row) => { row.hidden = true; row.querySelector('[data-nbg-recent-grid]').replaceChildren(); });
    }
  });
  dialog.addEventListener('close', () => { renderVersion++; opener?.focus(); });
  window.addEventListener('storage', (event) => {
    if (event.key === keys.saved || event.key === null) { saved = read(keys.saved); sync(); if (dialog.open) renderSaved(); }
  });
  const observer = new MutationObserver(() => sync());
  observer.observe(document.getElementById('PageContainer') || document.body, { childList: true, subtree: true });
  if (validHandle(labels.currentProduct)) {
    recent = [labels.currentProduct, ...recent.filter((handle) => handle !== labels.currentProduct)].slice(0, 24);
    write(keys.recent, recent);
  }
  if (!customElements.get('nbg-recent-pieces')) {
    customElements.define('nbg-recent-pieces', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.handles = recent.filter((handle) => handle !== this.dataset.currentHandle).slice(0, 6);
        if (!this.handles.length) return;
        this.hidden = false;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
        }, {rootMargin:'300px'});
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      async load() {
        const cards = await loadCards(this.handles);
        if (!this.isConnected || this.hidden) return;
        this.querySelector('[data-nbg-recent-grid]').replaceChildren(...cards);
        this.hidden = !cards.length;
        sync();
      }
    });
  }
  sync();
})();
